export const nodes = [
  {
    id: "center",
    label: "Ronak-Verse",
    x: 400,
    y: 300,
    url: null,
    info: "Welcome to Ronak-Verse, the gateway to various services.",
    size: 60,
  },
  {
    id: "games",
    label: "JavaScript Games",
    x: 270,
    y: 225,
    url: "https://github.com/Ronak-Malkan/JavaScriptGames",
    info: "Explore a collection of JavaScript-based games.",
    size: 40,
  },
  {
    id: "portfolio",
    label: "Portfolio",
    x: 530,
    y: 225,
    url: "http://portfolio.ronakverse.net",
    info: "View my professional portfolio.",
    size: 40,
  },
  {
    id: "puzzle",
    label: "Puzzle",
    x: 400,
    y: 450,
    url: "http://puzzle.ronakverse.net",
    info: "Engage with mind-bending puzzles.",
    size: 40,
  },
  {
    id: "two-cars",
    label: "Two Cars",
    x: 183,
    y: 175,
    url: "http://twocars.ronakverse.net",
    info: "Enjoy the racing experience of Two Cars.",
    size: 40,
  },
  {
    id: "type-it-to-lose-it",
    label: "Type It To Lose It",
    x: 357,
    y: 175,
    url: "http://typeit.ronakverse.net",
    info: "Test your typing speed with Type It To Lose It.",
    size: 40,
  },
];

export const links = [
  { source: "center", target: "games" },
  { source: "center", target: "portfolio" },
  { source: "center", target: "puzzle" },
  { source: "games", target: "two-cars" },
  { source: "games", target: "type-it-to-lose-it" },
];
